import React from 'react';
import {
  List, Datagrid, TextField, DateField, EditButton, ChipField, ReferenceField, RichTextField,
} from 'react-admin';

import { CaseStudiesFilter } from './components';
import { LongBodyField } from '../../../components';

const CaseStudiesList = props => (
  <List title="Case Studies" filters={<CaseStudiesFilter />} {...props}>
    <Datagrid rowClick="show">
      <TextField source="id" />
      <ReferenceField label="Category" source="category_id" reference="categories">
        <ChipField source="title" />
      </ReferenceField>
      <TextField source="title" />
      <LongBodyField source="description" />
      <RichTextField soruce="article" />
      <ReferenceField label="Created by" source="created_by" reference="users">
        <TextField source="username" />
      </ReferenceField>
      <DateField source="created_at" />
      <DateField source="updated_at" />
      <EditButton />
    </Datagrid>
  </List>
);

export default CaseStudiesList;
